import React, { memo } from 'react';
import UserProps from '../../proptypes/user';
import { MMMMYYYY } from '../../utils/time';
import style from '../../style/components/profile/WalletHeader.module.scss';
import WalletSectionCard from './WalletSectionCard';

const WalletHeader = ({ user }) => {
  const noName = !user.fname && !user.lname;
  const memberName = noName ? null : `${user.fname} ${user.lname}`;

  return (
    <WalletSectionCard>
      <div className={style.content}>
        {memberName && <div className={style.name}>{memberName}</div>}
        <div className={style.memberSince}>{MMMMYYYY(user.date)}</div>
      </div>
    </WalletSectionCard>
  );
};

WalletHeader.propTypes = {
  user: UserProps,
};

export default memo(WalletHeader);
